import { Box, Button, Flex, Icon } from '@chakra-ui/react';
import { useRouter } from 'next/dist/client/router';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { MdArrowBack } from 'react-icons/md';

type Props = {
  pageName: string;
};

const BreadCrumbs = ({ pageName }: Props) => {
  const { back } = useRouter();
  const { t } = useTranslation(`common`);
  return (
    <Flex
      direction="row"
      align="center"
      justify="start"
      className="boxed-container"
    >
      <Button
        onClick={back}
        variant="solid"
        color="brand.500"
        leftIcon={<Icon as={MdArrowBack} />}
        px="10"
        py="8"
        fontWeight="semibold"
        fontSize="lg"
      >
        {t(`bread_crumbs.back`)}
      </Button>
      <Box ms={9} as="span" fontSize="lg" fontWeight="semibold">
        {pageName}
      </Box>
    </Flex>
  );
};

export default BreadCrumbs;
